import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
//import './slider.scss'

function SampleNextArrow({ onClick }) {
  return (
    <button
      type="button"
      data-role="none"
      className="slick-arrow slick-next"
      style={{ display: 'block' }}
      onClick={onClick}
    >
      <span />
      <span />
    </button>
  )
}

function SamplePrevArrow({ onClick }) {
  return (
    <button
      type="button"
      data-role="none"
      className="slick-arrow slick-prev"
      style={{ display: 'block' }}
      onClick={onClick}
    >
      <span />
      <span />
    </button>
  )
}

class ImageSlider extends React.Component {
  constructor(props) {
    super(props)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
  }

  next() {
    this.slider.slickNext()
  }
  previous() {
    this.slider.slickPrev()
  }

  render() {
    var sliderSettings = this.props.settings
    var settings = {
      dots: false,
      nextArrow: <SampleNextArrow onClick={this.next} />,
      prevArrow: <SamplePrevArrow onClick={this.previous} />,
      slidesToShow: sliderSettings.slides_count,
      centerMode: sliderSettings.center_mode,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow:
              sliderSettings.slides_count >= 3
                ? 3
                : sliderSettings.slides_count,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow:
              sliderSettings.slides_count >= 2
                ? 2
                : sliderSettings.slides_count,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    }

    return (
      <div className="animated_slider">
        <Slider {...settings}>
          {this.props.slides.map((slide, i) => (
            <div className="item" key={i}>
              <div className="img-wrapper">
                <div dangerouslySetInnerHTML={{ __html: slide.image }} />
                <span className="img-caption">{slide.caption}</span>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    )
  }
}

ImageSlider.propTypes = {
  slides: PropTypes.array,
  settings: PropTypes.object,
}

SamplePrevArrow.propTypes = {
  onClick: PropTypes.func,
}

SampleNextArrow.propTypes = {
  onClick: PropTypes.func,
}

export default ImageSlider
